import React, { useEffect, useState } from "react";
import axiosInstance from "../../../utils/axiosInstance";
import Swal from "sweetalert2";
import DataTableComponent from "../../tools/DataTableComponent";
import { useFormik } from "formik";
import * as Yup from "yup";

const baseUrl = process.env.REACT_APP_BASE_URL;
const token = localStorage.getItem("token");

const validationSchema = Yup.object({
    nameLat: Yup.string().required("Le code est obligatoire"),
    descriptionLat: Yup.string().required("Le nom est obligatoire"),
});

const UnitOfMeasurement = () => {
    const [units, setUnits] = useState([]);
    const [form, setForm] = useState({
        id: 0,
        nameAr: "",
        nameLat: "",
        descriptionAr: "",
        descriptionLat: ""
    });
    const [selectedUnit, setSelectedUnit] = useState(null);

    useEffect(() => {
        fetchUnits();

    });

    const fetchUnits = () => {
        axiosInstance.get(`${baseUrl}/api/UnitsOfMeasurement`)
            .then(res => setUnits(res.data))
            .catch(() => console.log("Impossible de charger les données"));
    };

    const formik = useFormik({
        initialValues: {
            id: 0,
            nameAr: "",
            nameLat: "",
            descriptionAr: "",
            descriptionLat: ""
        },
        validationSchema,
        onSubmit: async (values, { setErrors, resetForm }) => {

            const url = values.id
                ? `${baseUrl}/api/UnitsOfMeasurement/UpdateUnit`
                : `${baseUrl}/api/UnitsOfMeasurement/CreateUnit`;

            const payload = {
                ...values,
                id: parseInt(values.id, 10),
            };

            try {
                await axiosInstance.post(url, payload);

                window.$("#modalForm").modal("hide");

                Swal.fire({
                    toast: true,
                    position: "top-end",
                    icon: "success",
                    title: "Enregistrement effectué avec succès",
                    showConfirmButton: false,
                    timer: 2000,
                });

                fetchUnits();
                resetForm();
                setSelectedUnit(null);

            } catch (error) {

                // 🔴 erreurs serveur (ModelState / ServiceResponse)
                if (error.response?.data?.errors) {
                    setErrors(error.response.data.errors);
                } else {
                    Swal.fire({
                        toast: true,
                        position: "top-end",
                        icon: "error",
                        title: "Opération échouée",
                        showConfirmButton: false,
                        timer: 2000,
                    });
                }
            }
        }
    });

    const resetForm = () => {
        formik.resetForm();
        setSelectedUnit(null);
    };

    const handleEdit = (unit) => {
        setSelectedUnit(unit);
        formik.setValues(unit);

        setTimeout(() => {
            window.$("#modalForm").modal("show");
        }, 100);
    };

    const handleDelete = (id) => {
        Swal.fire({
            title: "Êtes-vous sûr ?",
            text: "Cette action est irréversible !",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Oui, supprimer"
        }).then((result) => {
            if (result.isConfirmed) {
                axiosInstance.post(`${baseUrl}/api/UnitsOfMeasurement/DeleteUnit`,
                    { 'id': id, 'idString': '' }
                )
                    .then(() => fetchUnits());
            }
        });
    };

    return (
        <div className="container-fluid mt-4">
            <h3 className="text-center my-3">Gestion des Unités de Mesure</h3>
            <button className="btn btn-primary btn-ajouter mb-3" data-toggle="modal" data-target="#modalForm" onClick={resetForm}><i className="fas fa-plus"></i>Ajouter</button>

            <DataTableComponent
                data={units}
                title="Liste des Unités de Gestion"
                columns={["nameLat", "descriptionLat"]}
                columnsMapping={{
                    nameLat: "Code",
                    descriptionLat: "Nom"
                }}
                keyField="id"
                handleEdit={handleEdit}
                handleDelete={handleDelete}
            />

            {/* Modal Form */}
            <div className="modal fade" id="modalForm">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5>{selectedUnit ? "Modifier" : "Ajouter"} une unité</h5>
                            <button type="button" className="close" data-dismiss="modal">
                                <span>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="form-group">
                                <label>Code</label>
                                <input
                                    type="text"
                                    name="nameLat"
                                    className={`form-control ${formik.touched.nameLat && formik.errors.nameLat ? "is-invalid" : ""}`}
                                    value={formik.values.nameLat}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                                <div className="invalid-feedback">
                                    {formik.errors.nameLat}
                                </div>                            </div>
                            <div className="form-group">
                                <label>Nom</label>
                                <input
                                    type="text"
                                    name="descriptionLat"
                                    className={`form-control ${formik.touched.descriptionLat && formik.errors.descriptionLat ? "is-invalid" : ""}`}
                                    value={formik.values.descriptionLat}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                                <div className="invalid-feedback">
                                    {formik.errors.descriptionLat}
                                </div>                            </div>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" data-dismiss="modal" onClick={resetForm}>Annuler</button>
                            <button className="btn btn-primary" onClick={formik.handleSubmit}>Sauvegarder</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UnitOfMeasurement;
